import { render, staticRenderFns } from "./preference-form.vue?vue&type=template&id=3f416a2a&"
import script from "./preference-form.vue?vue&type=script&lang=js&"
export * from "./preference-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports